import { Person } from "@/types/person"

/**
 * Format a person as `${person_id}-${FirstName}${LastName}` for compact
 * references (e.g. the primary person and substitute driver lists on the
 * People CRM screen).
 */
export const formatPersonShortName = (
  person: Pick<Person, "person_id" | "first_name" | "surname">,
): string => `${person.person_id}-${person.first_name || ""}${person.surname || ""}`
